// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.79 2.21C7.54 1.77 8.46 1.77 9.21 2.21L12.81 4.31C13.55 4.74 14 5.52 14 6.38L14 9.62C14 10.48 13.55 11.26 12.81 11.69L9.21 13.79C8.46 14.23 7.54 14.23 6.79 13.79L3.19 11.69C2.45 11.26 2 10.48 2 9.62L2 6.38C2 5.52 2.45 4.74 3.19 4.31Z',
  'M2.32 5.18L8 8.25L13.68 5.18',
  'M8 8.25L8 14.12',
];
